<template>
  <div class="app-container">
      <h2>{{teamData.name}}</h2>
    
    <h3><span style="vertical-align:top;">团队信息</span><el-button type="primary" plain size="small" @click.native="editMainTeamItme()" style="width:60px;margin-left:20px;">编辑</el-button></h3>
    <div class="team-info">
        <el-row>
            <el-col :span="2"><div class="grid-content">团队id：</div></el-col>
            <el-col :span="22"><div class="grid-content">{{teamData.team_number}}</div></el-col>
        </el-row>
        <el-row>
            <el-col :span="2"><div class="grid-content">队长：</div></el-col>
            <el-col :span="22"><div class="grid-content">{{teamData.realname}}</div></el-col>
        </el-row>
        <el-row>
            <el-col :span="2"><div class="grid-content">联系方式：</div></el-col>
            <el-col :span="22"><div class="grid-content">{{teamData.tel}}</div></el-col>
        </el-row>
        <el-row>
            <el-col :span="2"><div class="grid-content">管理区域：</div></el-col>
            <el-col :span="22"><div class="grid-content">{{teamData.area}}</div></el-col>
        </el-row>
    </div>

    <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
    
    <div class="title-wrap">
        <h3>负责项目</h3>
        <div class="title-right">
            <el-input placeholder="请输入内容" v-model="searchProjectVal" class="input-with-select">
                <el-select v-model="searchProjectSelectVal" slot="prepend" placeholder="请选择">
                    <el-option label="项目名称" value="item_name"></el-option>
                    <el-option label="客户姓名" value="realname"></el-option>
                    <el-option label="联系方式" value="tel"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="onSearchProjectBut"></el-button>
            </el-input>
        </div>
    </div>
    <!-- 项目 表格 -->
    <el-table :data="projectData" row-key="id" stripe style="width: 100%">
      <el-table-column align="center" type="index" label="序号" width="100"> </el-table-column>
      <el-table-column align="center" prop="item_name" label="项目名称"> </el-table-column>
      <el-table-column align="center" prop="realname" label="客户" sortable> </el-table-column>
      <el-table-column align="center" prop="tel" label="客户联系"> </el-table-column>
      <el-table-column align="center" prop="e_number" label="设备数"> </el-table-column>
      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="routerPush(scope.row),drawer = true" slot="reference" type="text" size="small">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:60px 0 30px;" /> 
    
    <div class="title-wrap">
        <h3>团队人员</h3>
        <div class="title-right">
            <el-input placeholder="请输入内容" v-model="searchTUserVal" class="input-with-select">
                <el-select v-model="searchTUserSelectVal" slot="prepend" placeholder="请选择">
                    <el-option label="姓名" value="u_realname"></el-option>
                    <el-option label="身份证号" value="u_idcard"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="onSearchTUserBut"></el-button>
            </el-input>
        </div>
    </div>
    <!-- 团队 表格 -->
    <el-table :data="tUserData" row-key="id" stripe style="width: 100%">
      <el-table-column align="center" type="index" label="序号" width="100"> </el-table-column>
      <el-table-column align="center" prop="realname" label="姓名"> </el-table-column>
      <el-table-column align="center" prop="is_team" label="身份" sortable> </el-table-column>
      <el-table-column align="center" prop="tel" label="联系方式"> </el-table-column>
      <el-table-column align="center" prop="idcard" label="身份证号"> </el-table-column>

      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <el-button @click="editTuserItme(scope.row),drawer = true" slot="reference" type="text" size="small" icon="el-icon-edit">编辑</el-button>
          <el-button @click="resetPass(scope.row)" type="text" size="small" icon="el-icon-lock">密码重置</el-button>
          <el-button @click="deleteTuserItme(scope.row)" type="text" size="small" icon="el-icon-delete">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="tUserBut">
        <el-button type="primary" @click.native="handleAddTuser(null,null)" style="width:200px" icon="el-icon-plus">添加团队成员</el-button>
    </div>

    <!--新增队员表单-->
    <el-dialog title="团队信息" :visible.sync="addTuserVisible" :before-close="hideAddTuser" :close-on-click-modal="false" width="1200px" top="5vh">
        <div class="">
            <div class="itme-text">
                <div class="label">团队ID：</div>
                <div class="content">{{teamData.team_number}}</div>
            </div>
            <div class="itme-text">
                <div class="label">团队名称：</div>
                <div class="content">{{teamData.name}}</div>
            </div>
            <div class="itme-text">
                <div class="label">负责区域：</div>
                <div class="content">{{teamData.area}}</div>
            </div>
        </div>

        <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
    
        <h3 class="el-dialog__title">队员配置</h3>
        <el-form :model="userArr" :rules="addTuserRules" :inline="true" ref="dataForm" label-width="80px">
            <div class="addTuserItme">
                <el-form-item label="名字" prop="realname">
                    <el-input v-model="userArr.realname" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="身份" prop="is_team">
                    <el-select v-model="userArr.is_team" placeholder="请选择" style="width:100px">
                        <el-option label="队长" value="1"></el-option>
                        <el-option label="队员" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号" prop="tel">
                    <el-input v-model="userArr.tel" placeholder="" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="idcard">
                    <el-input v-model="userArr.idcard" placeholder="" maxlength="18"></el-input>
                </el-form-item>
            </div>
            
            <div class="addTuserItme" v-for="(item, index) in userArr.addUserArr" :key="index">
                <el-form-item label="名字" :prop="'addUserArr.' + index + '.realname'" :rules="{required: true, message: '请输入队员名字', trigger: 'blur'}">
                    <el-input v-model="item.realname"></el-input>
                </el-form-item>
                <el-form-item label="身份" :prop="'addUserArr.' + index + '.is_team'" :rules="{required: true, message: '请选择队员的身份', trigger: 'blur'}">
                    <el-select v-model="item.is_team" value-key="is_team" placeholder="请选择" style="width:100px">
                        <el-option label="队长" value="1"></el-option>
                        <el-option label="队员" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号" :prop="'addUserArr.' + index + '.tel'" :rules="{required: true, message: '请输入手机号码', trigger: 'blur'}">
                    <el-input v-model="item.tel" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" :prop="'addUserArr.' + index + '.idcard'" :rules="{required: true, message: '请输入身份证号码', trigger: 'blur'}">
                    <el-input v-model="item.idcard" maxlength="18"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="text" @click.native="addTuserItmeDel(item, index)" icon="el-icon-close"></el-button>
                </el-form-item>
            </div>
            
            <div class="tUserBut">
                <el-button type="primary" @click.native="addTuserItme(null,null)" icon="el-icon-plus" plain>添加更多成员</el-button>
            </div>
            <div class="tUserBut">
                <el-button type="primary" @click.native="addTuserItmeFormSubmit()" style="width:200px">保 存</el-button>
            </div>
        </el-form>
    
    
    </el-dialog>
    
    <!--编辑团队表单-->
    <el-dialog title="团队信息" :visible.sync="editTeamVisible" :before-close="hideEditTeam" :close-on-click-modal="false" width="1200px" top="5vh">
        <el-form :model="editTeamArr" :inline="true" ref="dataForm" label-width="80px">
            <el-form-item label="团队ID：" style="width:100%">
                <div class="content">{{teamData.team_number}}</div>
            </el-form-item>
            <el-form-item label="团队名称" style="width:100%">
                <el-input v-model="editTeamArr.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="负责区域" style="width:100%">
                <el-input v-model="editTeamArr.area" auto-complete="off"></el-input>
            </el-form-item>
        </el-form>
            
        <div class="tUserBut">
            <el-button type="primary" @click.native="editTeamSubmit()" style="width:200px">保 存</el-button>
        </div>
    
    </el-dialog>
    
    <!--编辑队员表单-->
    <el-dialog title="团队信息" :visible.sync="editTuserVisible" :before-close="hideEditTuser" :close-on-click-modal="false" width="1200px" top="5vh">
        <el-form :model="editUserArr" :inline="true" ref="dataForm" label-width="80px">
            <div class="">
                <div class="itme-text">
                    <div class="label">团队ID：</div>
                    <div class="content">{{editUserArr.team.team_number}}</div>
                </div>
                <div class="itme-text">
                    <div class="label">团队名称：</div>
                    <div class="content">{{editUserArr.team.name}}</div>
                </div>
                <div class="itme-text">
                    <div class="label">负责区域：</div>
                    <div class="content">{{editUserArr.team.area}}</div>
                </div>
            </div>

            <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
        
            <h3 class="el-dialog__title">队员信息</h3>
            <div class="addTuserItme">
                <el-form-item label="名字">
                    <el-input v-model="editUserArr.user.realname" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="身份">
                    <el-select v-model="editUserArr.user.is_team" placeholder="请选择" style="width:100px">
                        <el-option label="队长" value="1"></el-option>
                        <el-option label="队员" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="editUserArr.user.tel" placeholder="" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model="editUserArr.user.idcard" placeholder="" maxlength="18"></el-input>
                </el-form-item>
            </div>
            
            <div class="tUserBut">
                <el-button type="primary" @click.native="editTuserItmeFormSubmit()" style="width:200px">保 存</el-button>
            </div>
        </el-form>
    
    
    </el-dialog>

    <!-- 登录密码重置 -->
    <el-dialog title="登录密码重置" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
        <span>您将进行重置密码操作，重置后原登录密码将不可用，新登录密码为“123456”</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="resetPassTuserItme">确 定</el-button>
        </span>
    </el-dialog>

  </div>
</template>



<script>
    import {
        apiTeamdetailsData,
        apiWuserEditData,
        apiWuserEdit,
        apiAddwTeamuser,
        apiResetPassword,
        apiWuserDelete,
        apiWuserTeamEditData,
        apiWuserTeamEditSubmit
    } from "../../api/views/maintain";
    import {isvalidPhone,checkIdNum} from "../../utils/rules";

    const formJson = {
        team:{
            t_id: ''
        },
        user_arr: {
            "0":{
                "realname":"",//队员名称
                "is_team":"",//0.队员 1.队长
                "tel":"",//手机号
                "idcard":""//身份证号
            }
        },
    }
    const validPhone=(rule, value,callback)=>{
        if (!value){
            callback(new Error('请输入手机号码'))
        }else  if (!isvalidPhone(value)){
            callback(new Error('请输入正确的11位手机号码'))
        }else {
            callback()
        }
    }
    const valcheckIdNum=(rule, value,callback)=>{
        if (!value) {
            return callback(new Error('证件号码不能为空'))
        } else if (!checkIdNumt(value)) {
            return callback(new Error('证件号码不正确'))
        } else {
            callback()
        }
    }
    export default {
        data () {
            return {
                tid: '',
                query:{
                    id: "",
                },
                teamData: [],
                projectData: [],
                tUserData: [],
                
                searchProjectVal: '',
                searchProjectSelectVal: '',
                searchTUserVal:'',
                searchTUserSelectVal: '',

                dialogVisible: false,
                addTuserVisible: false,
                editTuserVisible: false,
                formLabelAlign:'',
                addTuserRules:{
                    realname: [{ required: true, message: "请输入队员名字", trigger: "blur" }],
                    is_team: [{ required: true, message: "请选择队员的身份", trigger: "blur" }],
                    tel: [{ required: true, trigger: 'blur', validator: validPhone }],
                    idcard: [{ required: true, message: "请输入身份证号码", trigger: "blur" }]
                },
                addTuserData: formJson,
                userArr:{
                    "realname":"",//队员名称
                    "is_team":"0",//0.队员 1.队长
                    "tel":"",//手机号
                    "idcard":"",//身份证号
                    addUserArr: []
                },
                addUserArr:[],
                editUserArr:{
                    "team": {
                        "id": 1,
                        "team_number": "wb001",
                        "name": "维保1大队",
                        "area": "南宁青秀区1"
                    },
                    "user": {
                        "id": 47,
                        "realname": "99",
                        "is_team": 0,
                        "tel": "13666666666",
                        "idcard": "你"
                    }
                },
                editTeamVisible: false,
                editTeamArr: {}

            }
        },
        created:function() {
            if(this.$route.query.id){
                this.βgetApp.globalData.maintainID = this.$route.query.id
                this.query.id = this.βgetApp.globalData.maintainID
                console.log(this.query)
                this.getList(this.query)
            }else{
                let maintainQuery = {id:this.βgetApp.globalData.maintainID}
                this.getList(maintainQuery)
            }
        },
        methods: {
            getList(query){
                const that = this
                apiTeamdetailsData(query).then(res => {
                    // console.log(res)
                    if(res.code != 1){
                        for(let i of res.t_user) i.is_team = i.is_team == 1 ? '队长': '队员'
                        that.projectData = res.project
                        that.tUserData = res.t_user
                        that.teamData = res.team
                        that.tid = res.team.id
                    }else{
                        that.$message({
                            message: res.message,
                            type: "error"
                        })
                    }
                }).catch(err => {
                    console.log('获取列表-失败',err)
                    that.$message({
                      message: '获取列表-失败',
                      type: "error"
                    })
                })
            },
            onSearchProjectBut(){
                this.query = {}
                this.query.id = this.βgetApp.globalData.maintainID
                this.query[this.searchProjectSelectVal] = this.searchProjectVal
                if(this.searchProjectSelectVal && this.searchProjectVal){
                    this.getList(this.query)
                }else if(!this.searchProjectSelectVal){
                    this.$message({
                      message: '搜索类型不能为空',
                      type: "error"
                    })
                }else if(!this.searchProjectVal){
                    this.$message({
                      message: '搜索内容不能为空',
                      type: "error"
                    })
                }
            },
            onSearchTUserBut(){
                this.query = {}
                this.query.id = this.βgetApp.globalData.maintainID
                this.query[this.searchTUserSelectVal] = this.searchTUserVal
                if(this.searchTUserSelectVal && this.searchTUserVal){
                    this.getList(this.query)
                }else if(!this.searchTUserSelectVal){
                    this.$message({
                      message: '搜索类型不能为空',
                      type: "error"
                    })
                }else if(!this.searchTUserVal){
                    this.$message({
                      message: '搜索内容不能为空',
                      type: "error"
                    })
                }
            },
            
            hideAddTuser() {
                // 更改值
                this.addTuserVisible = !this.addTuserVisible;
                // 清空表单
                this.$refs["dataForm"].resetFields()
                // this.addTuserData = []
                this.userArr = {
                    "realname":"",
                    "is_team":"0",
                    "tel":"",
                    "idcard":"",
                    addUserArr: []
                }
                return true;
            },
            handleAddTuser(index, row){
                this.addTuserVisible = true;
                this.addTuserData = Object.assign({}, formJson);
                if (row !== null) {
                    this.addTuserData = Object.assign({}, row);
                }
                this.addTuserData.team.t_id = this.tid
            },
            addTuserItmeDel(item, index){
                this.userArr.addUserArr.splice(index, 1)
            },
            addTuserItme(index, row) {
                if(!this.userArr.addUserArr) this.userArr = {
                    "realname":"",
                    "is_team":"0",
                    "tel":"",
                    "idcard":"",
                    addUserArr: []
                }
                this.userArr.addUserArr.push({
                    "realname":"",
                    "is_team":"0",
                    "tel":"",
                    "idcard":""
                }) 
            },
            addTuserItmeFormSubmit() {
                const that = this, addTuserData = JSON.parse(JSON.stringify(that.addTuserData))
                that.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        console.log("this.addTuserData",that.addTuserData)
                        let userArr = JSON.parse(JSON.stringify(that.userArr)), addUserArr = that.userArr.addUserArr, userArrArr = []
                        delete userArr.addUserArr
                        userArrArr.push(userArr)
                        let newArr = userArrArr.concat(addUserArr)
                        addTuserData.user_arr = newArr
                        let data = Object.assign({}, addTuserData)
                        console.log(data)
                        apiAddwTeamuser(data).then(response => {
                            console.log(response)
                            if (response.code == 0) {
                                that.$message({
                                    message: "操作成功",
                                    type: "success"
                                });
                                // 更改值
                                that.addTuserVisible = !that.addTuserVisible;
                                // 清空表单
                                that.$refs["dataForm"].resetFields()
                                // 刷新列表
                                that.getList(that.query)
                            }else{
                                that.$message({
                                    message: response.message,
                                    type: "error"
                                });
                                console.log("userArr",userArr)
                                console.log("userArr",that.userArr)
                            }
                        })
                    }
                })
            },
            editTuserItme(row){
                const that = this
                let query = {
                    tid: that.βgetApp.globalData.maintainID,
                    uid: row.id
                }
                apiWuserEditData(query).then(res => {
                    this.editTuserVisible = true
                    res.user.is_team = res.user.is_team == 1 ? '队长': '队员'
                    that.editUserArr = res
                })
            },
            hideEditTuser(){
                this.editTuserVisible = false

            },
            editTuserItmeFormSubmit(){
                const that = this
                if(that.editUserArr.user.is_team == '队员') that.editUserArr.user.is_team = 0
                if(that.editUserArr.user.is_team == '队长') that.editUserArr.user.is_team = 1
                let data = Object.assign({}, that.editUserArr.user)
                apiWuserEdit(data).then(res => {
                    if (res.code == 0) {
                        that.$message({
                            message: res.message,
                            type: "success"
                        });
                        // 更改值
                        that.editTuserVisible = !that.editTuserVisible;
                        // 清空表单
                        that.$refs["dataForm"].resetFields()
                        // 刷新列表
                        that.getList(that.query)
                    }else{
                        that.$message({
                            message: res.message,
                            type: "error"
                        })
                    }
                })
            },
            resetPass(row){
                console.log(row)
                this.dialogVisible = !this.dialogVisible
                this.resetPassTuserItmeId = row.id
            },
            resetPassTuserItme(){
                const that = this
                console.log(this.resetPassTuserItmeId)
                let data = {id:this.resetPassTuserItmeId}
                apiResetPassword(data).then(res => {
                console.log(data)
                    if (res.code == 0) {
                        this.$message({
                            message: res.message,
                            type: "success"
                        });
                        this.dialogVisible = !this.dialogVisible
                        this.resetPassTuserItmeId = ''
                        // 刷新列表
                        this.getList(that.query)
                    }else{
                        this.$message({
                            message: res.message,
                            type: "error"
                        })
                    }
                })
            },
            handleClose(done) {
                this.dialogVisible = !this.dialogVisible
            },
            deleteTuserItme(row){
                let query = {
                    id: row.id,
                    tid: this.βgetApp.globalData.maintainID
                }
                console.log(query)
                this.$confirm('确认删除？', '提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( async () => {
                    await apiWuserDelete(query).then(res => {
                        console.log(res)
                        console.log(res.message)
                        if(res.code == 0){
                            this.$message({
                                message: res.message,
                                type: "success"
                            })
                            this.getList(this.query)
                        }else{
                            this.$message({
                                message: res.message,
                                type: "error"
                            })
                        }
                    })
                }).catch(_ => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            routerPush(row){
                console.log('row',row)
                this.$router.push({path:'/customer/details',query:{id:row.uid}});
            },
            objToArr(obj) {
                var arr = [];
                for (var i in obj) {
                    var newObj = {};
                    newObj[i] = obj[i];
                    arr.push(newObj)
                }
                return arr;
            },



            Person(name, job) {
                // 属性 
                this.name = name; this.job = job; 
                // 方法 
                if(typeof this.sayName !== 'function') {
                    Person.prototype.sayName = function() {
                        console.log(this.name)
                    } 
                }
            },
                    //   var person1 = new Person('Mike', 'Student')
                    // person1.sayName()
            createPerson(name, job) {
                var o = new Object();
                o.name = name;
                o.job = job;
                o.sayName = function() {  console.log(this.name); }
                return o
            },
            // var person1 = createPerson('Mike', 'student')
            // var person2 = createPerson('X', 'engineer')

            editMainTeamItme(){
                console.log('编辑维保团队信息')
                this.editTeamVisible = true
                apiWuserTeamEditData({id:this.βgetApp.globalData.maintainID}).then(res => {
                    console.log(res)
                    this.editTeamArr = res
                })

            },
            hideEditTeam(){
                this.editTeamVisible = false
            },
            editTeamSubmit(){
                console.log(this.editTeamArr)
                let data = this.editTeamArr
                apiWuserTeamEditSubmit(data).then(res => {
                    if(res.code == 0){
                        this.$message({
                            message: res.message,
                            type: "success"
                        })
                        this.getList(this.query)
                    }else{
                        this.$message({
                            message: res.message,
                            type: "error"
                        })
                    }
                    this.editTeamVisible = false
                })
            }
        }
    }
</script>


<style lang="scss" scoped>
  .app-container{
    color: #1f2f3d;
  }
  .app-container h2{
    display: block;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    font-weight: 400;
    color: #1f2f3d;
    font-size: 28px;
  }
  .app-container h3{
    display: block;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    font-weight: 400;
    color: #1f2f3d;
    font-size: 22px;
  }
  .app-container h3.el-dialog__title {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
}
  .team-info{
      margin-bottom: 50px;
  }
  .team-info .el-row{
      margin: 10px;
      font-size: 14px;
  }
  .title-wrap {
      position: relative;
  }
  .title-right{
      position: absolute;
      top: 0;
      right: 10px;
  }
  .el-input-group__prepend .el-select{
    width: 120px;
  }
  .input-with-select .el-input__inner {
    width: 250px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  .tUserBut{
      text-align: center;
      margin: 40px 0;
  }
    .itme-text{
        display: flex;
        .label {
            width: 130px;
            text-align: right;
            float: left;
            font-size: 14px;
            color: #606266;
            line-height: 40px;
            padding: 0 12px 0 0;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            margin-left: 20px;
        }
        .content {
            flex: 1;
            line-height: 40px;
            position: relative;
            font-size: 14px;
        }
    }
  .itme-text label.el-form-item__label{
    width: 80px !important;
  }
</style>
